import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants'
import { message } from 'antd'
import { checkAuthorization } from '../../../helpers'

export const login = createAsyncThunk('login',
    async (data, { dispatch, getState }) => {
        dispatch(getting())
        var myHeaders = new Headers()
        myHeaders.append("Content-Type", "application/json")
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify(data)
        }
        fetch(domainUrl + "/professionalLogin", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.success) {
                    localStorage.setItem('token', JSON.stringify(result?.user?.token))
                    localStorage.setItem('refreshToken', result.user.refreshToken);
                    dispatch(loginResponse(result?.user))
                    window.location.href='/'
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                message.error(error)
                dispatch(loginClear()) 
            })
    }
)

export const refreshToken = createAsyncThunk('refreshToken',
    async (_, { dispatch }) => {
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) {
            throw 'Refresh token not found';
        }
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({ refreshToken })
        };
        return fetch(domainUrl + "/refreshToken", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.success) {
                    localStorage.setItem('token', JSON.stringify(result?.user?.token))
                    dispatch(loginResponse({ token: result.token }));
                    return result.token;
                    
                } else {
                    throw result.message;
                }
            });
    }
);

export const forgotPassword = createAsyncThunk('forgot',
    async (data, { dispatch, getState }) => {
        dispatch(getting())
        var myHeaders = new Headers()
        myHeaders.append("Content-Type", "application/json")
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify(data)
        }
        fetch(domainUrl + "/forgotPassword", requestOptions)
            .then(response => response.json())
            .then(result => {
                dispatch(loginClear())
                if (result.success) 
                {
                    message.success(result?.message || 'OTP sent to your email.');
                    dispatch(forgotPasswordResponse(result));
                }
                else 
                    throw result?.error
            })
            .catch(error => { 
                message.error(error || 'Forgot Password request failed');
                dispatch(loginClear())
            })
    }
)

// OTP Verify
export const otpVerify = createAsyncThunk('otpVerify',
    async (data, { dispatch }) => {
        dispatch(getting());
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify(data),
        };

        fetch(domainUrl + "/verifyOtp", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.success) {
                    message.success(result?.message || 'OTP verified successfully.');
                    dispatch(otpResponse(result?.token));
                } else {
                    throw result?.message;
                }
            })
            .catch(error => {
                message.error(error || 'OTP verification failed');
                dispatch(loginClear());
            });
    }
);

// Reset Password
export const resetPassword = createAsyncThunk('resetPassword',
    async ({data,navigate}, { dispatch }) => {
        dispatch(getting());
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify(data),
        };

        fetch(domainUrl + "/resetPassword", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.success) {
                    message.success(result?.message || 'Password reset successfully.');
                    navigate('/login')
                    dispatch(resetResponse(result));
                } else {
                    throw result?.message;
                }
            })
            .catch(error => {
                message.error(error || 'Password reset failed');
                dispatch(loginClear());
            });
    }
);

export const AuthCheck = createAsyncThunk('LoginCheck',
    async (_, { dispatch, getState }) => {
        const { userToken }= checkAuthorization()
        dispatch(gettingLoginCheck())
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };
        fetch(domainUrl + `/loginCheck`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    const user = localStorage.getItem('userRole');
                    dispatch(loginResponse(JSON.parse(user)))
                    
                }
                else {
                    throw result?.message
                }
            })
            .catch(error => {
                dispatch(loginClear())
            })
    }
)


const loginSlice = createSlice({
    name: 'login',
    initialState: {
        data: null,
        loading: false,
        LoginCheckloading: false,
        otpToken: null,
        requestState : "request"
    },
    reducers: {
        getting: state => {
            state.loading = true
        },
        loginResponse: (state, action) => {
            state.data = action.payload
            state.loading = false
            state.LoginCheckloading = false
        },
        forgotPasswordResponse: (state, action) => {
            state.data = action.payload;
            state.requestState = "otp"
            state.loading = false;
        },
        otpResponse: (state, action) => {
            state.otpToken = action.payload;
            state.requestState = "reset"
            state.loading = false;
        },
        loginClear: state => {
            state.data = null
            state.loading = false
            state.LoginCheckloading = false
        },
        resetResponse: (state, action) => {
            state.data = action.payload;
            state.loading = false;
            state.token = null
        },
        gettingLoginCheck: state => {
            state.LoginCheckloading = true
        }
    },
    extraReducers: builder => {
        builder
            .addCase(refreshToken.fulfilled, (state, action) => {
                state.data.token = action.payload;
            });
    }
})

export const { getting, loginResponse, loginClear, gettingLoginCheck, otpResponse ,resetResponse, forgotPasswordResponse } = loginSlice.actions;
export default loginSlice.reducer;